export default __webpack_public_path__ + "Open_Roll_Medium_Large_Single.png";